import React from 'react';
import { toast as sonnerToast } from 'sonner';
import Image from 'next/image';
import errorIcon from '../../assets/images/errorToast.svg';
import successIcon from '../../assets/images/successToast.svg';

export function toast(type: 'success' | 'error', message: string) {
  if (type === 'success') {
    sonnerToast.success(message, {
      icon: <Image src={successIcon} alt='Success' />,
      style: {
        backgroundColor: '#00AE30',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 700,
        padding: '20px',
        borderRadius: '16px',
        border: 'none',
      },
    });
  } else if (type === 'error') {
    sonnerToast.error(message, {
      icon: <Image src={errorIcon} alt='Error' />,
      style: {
        backgroundColor: '#E5532A',
        color: '#fff',
        fontSize: '16px',
        fontWeight: 700,
        padding: '20px',
        borderRadius: '16px',
        border: 'none',
      },
    });
  } else {
    sonnerToast(message, {});
  }
}
